/*
  src/redux/version/reducer.js

  Created by erikchristensen on 11/03/2016.
  Copyright © 2016 myNfo. All rights reserved.
*/

import update from 'immutability-helper';

import {VERSION_LOADED} from './constants';

import { stripBuildFromTag } from '../../../shared/utils'

const initialState = {
  environment:null,
  frontend:null,
  backend:null
};

export default function(state=initialState,action){
  switch(action.type){

  case VERSION_LOADED:
    return update(state,{
      $set:{
        environment:action.payload.environment,
        frontend:stripBuildFromTag(action.payload.frontend),
        backend:stripBuildFromTag(action.payload.backend)
      }
    });

  default:
    return update(state,{});
  }
}



// WEBPACK FOOTER //
// ./src/shared/redux/version/reducer.js